// extracted by mini-css-extract-plugin
export var chatHtmlText = "_op-2";
export var chatLink = "_op-0";
export var chatText = "_op-1";